// Parse an hours input that can be either decimal (3.25) or hh:mm (3:15)
// Returns the decimal hours value, or NaN if invalid.
export function parseHoursInput(value: string): number {
  const trimmed = value.trim();
  if (!trimmed) return 0;

  // hh:mm format
  if (trimmed.includes(':')) {
    const parts = trimmed.split(':');
    if (parts.length !== 2) return NaN;
    const h = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    if (isNaN(h) || isNaN(m) || m < 0 || m >= 60) return NaN;
    return h + m / 60;
  }

  // Decimal format
  return parseFloat(trimmed);
}

// Convert decimal hours to hh:mm string
export function decimalToHHMM(hours: number): string {
  if (!hours || hours <= 0) return '0:00';
  let h = Math.floor(hours);
  let m = Math.round((hours - h) * 60);
  if (m >= 60) { h += 1; m = 0; }
  return `${h}:${m.toString().padStart(2, '0')}`;
}

// Format hours for display: "3.25 (3:15)"
export function formatHours(hours: number): string {
  if (!hours || hours <= 0) return '0';
  const decimal = hours.toFixed(2).replace(/\.?0+$/, '');
  const hhmm = decimalToHHMM(hours);
  return `${decimal} (${hhmm})`;
}
